import React from 'react';

export const Alert = ({ children, className }) => {
  return (
    <div className={`alert ${className}`}>
      {children}
    </div>
  );
};

export const AlertTitle = ({ children }) => {
  return (
    <p className="alert-title">
      {children}
    </p>
  );
};

export const AlertDescription = ({ children }) => {
  return (
    <p className="alert-description">
      {children}
    </p>
  );
};
